export default __webpack_public_path__ + "static/media/00.5eec0f4c.jpg";